import { useMutation } from 'react-query';
import axios from 'utilities/axios';

const API = {
  CREATE_TRANSACTION: '/payments/transactions',
  PAYMENT_TOPUP: '/payments/topup',
};
export const useCreateTransaction = () => {
  return useMutation(async (formData) => {
    const { data } = await axios.post(API.CREATE_TRANSACTION, { ...formData });
    return data;
  });
};

export const usePaymentTopUp = () => {
  return useMutation(async (data) => {
    const { data: response } = await axios.post(API.PAYMENT_TOPUP, data);

    return response;
  });
};
